module.exports = __webpack_public_path__ + "img/connect_vm.93f54007.svg";